import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

import { getFirebaseConfig } from "./firebaseConfig";

// Create a singleton Firebase app instance.
// CRA hot reload can re-run modules; getApps() prevents duplicate initialization.
export function getFirebaseApp() {
  if (getApps().length) return getApps()[0];
  return initializeApp(getFirebaseConfig());
}

export const firebaseApp = getFirebaseApp();

// Expose common Firebase services for the rest of the app.
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
